import { render } from "./DisplayCrypto.vue?vue&type=template&id=4e1f0eb8&scoped=true"
import script from "./DisplayCrypto.vue?vue&type=script&lang=js"
export * from "./DisplayCrypto.vue?vue&type=script&lang=js"

import "./DisplayCrypto.vue?vue&type=style&index=0&id=4e1f0eb8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e1f0eb8"]])

export default __exports__